export default {
  year: 2024,
  edition: "제 20회",
  date: "2024년 11월 9일 토요일",
  time: "오후 2시 ~ 5시",
  location: "다산관 D104/D105",
  links: {
    problems: {
      BOJ: "https://www.acmicpc.net/category/1063",
    },
    solutions: {
      PDF: "/downloads/spc/2024/solutions.pdf",
    },
  },
  authors: ["강효규", "박수현", "박준영", "송근수", "이승형", "조원빈"],
  contests: [
    {
      title: "SPC 2024 Master",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "5", "김규민"],
        ["2", "5", "김형은"],
        ["3", "5", "이재찬"],
        ["4", "5", "김대원"],
        ["5", "5", "심진희"],
        ["6", "5", "신동혁"],
      ],
      award: ["gold", "silver", "silver", "bronze", "bronze", "bronze"],
      links: [["스코어보드", "https://www.acmicpc.net/contest/spotboard/1385"]],
    },
    {
      title: "SPC 2024 Champion",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "7", "박성준"],
        ["2", "6", "김동건"],
        ["3", "6", "김진수"],
        ["4", "5", "유호영"],
        ["5", "5", "김서인"],
        ["6", "4", "하건영"],
        ["7", "4", "김현종"],
      ],
      award: [
        "winner",
        "gold",
        "silver",
        "silver",
        "bronze",
        "bronze",
        "bronze",
      ],
      links: [["스코어보드", "https://www.acmicpc.net/contest/spotboard/1386"]],
    },
  ],
};
